import { Box, Grid } from "@chakra-ui/react";
import { InputField, InputFieldProps } from "components/input-field";

export function CalendarFilter({
  onChange,
  filter,
  keyDataFim,
  keyDataInicio,
  leftInputProps,
  rightInputProps,
}: {
  onChange: (value: any, key: any) => void;
  filter: any;
  keyDataInicio: string;
  keyDataFim: string;
  leftInputProps?: InputFieldProps;
  rightInputProps?: InputFieldProps;
}) {
  return (
    <Grid templateColumns="1fr 1fr" w="100%" gap="7px">
      <Box>
        <InputField
          inputProps={{
            variant: "outline-gray",
            height: "48px",
            type: "date",
            onClick: (e) => e.stopPropagation(),
            border: leftInputProps?.errorMessage
              ? "3px solid var(--chakra-colors-secondary-600)"
              : undefined,
          }}
          value={filter[keyDataInicio] || ""}
          onChange={(e) => {
            onChange(e.target.value, keyDataInicio);
          }}
          {...leftInputProps}
        />
      </Box>
      <Box>
        <InputField
          inputProps={{
            variant: "outline-gray",
            height: "48px",
            type: "date",
            onClick: (e) => e.stopPropagation(),
            border: rightInputProps?.errorMessage
              ? "3px solid var(--chakra-colors-secondary-600) !important"
              : undefined,
          }}
          value={filter[keyDataFim] || ""}
          onChange={(e) => {
            onChange(e.target.value, keyDataFim);
          }}
          {...rightInputProps}
        />
      </Box>
    </Grid>
  );
}
